<script lang="ts">
  import Image from './image.svelte';
  import { buildSrcSet, buildSizes, type SrcSetConfig, type SizesConfig } from '$lib/image';
  import { resizeShopifyImage } from '$lib/shopify';

  export let src: string;
  export let widths: SrcSetConfig['widths'] | undefined = undefined;
  export let sizes: string | SizesConfig<string> | undefined = undefined;
  export let loader: SrcSetConfig['loader'] = ({ width }) => resizeShopifyImage(src, width);

  $: srcset =
    buildSrcSet({
      loader: loader,
      widths: widths ?? [$$props.width || null]
    }) || undefined;
</script>

<Image
  {src}
  {srcset}
  sizes={typeof sizes === 'string' ? sizes : sizes ? buildSizes(sizes) : undefined}
  {...$$restProps}
/>
